// BHP-1044: the quote selected on the overview and read by the detail page is a
// client-state hand-off (the detail route has no id and there is no by-id
// endpoint), so it lives in Zustand — replacing quoteReducer.quoteDetails.
import { create } from 'zustand';
import type QuoteData from '../../../Models/QuoteData';

interface QuoteSelectionState {
  selectedQuote: QuoteData | null;
  selectQuote: (quote: QuoteData | null) => void;
}

export const useQuoteSelectionStore = create<QuoteSelectionState>((set) => ({
  selectedQuote: null,
  selectQuote: (quote) => set({ selectedQuote: quote })
}));
